import React, { useState } from 'react';
import { Dialog } from '@material-ui/core';

import GaraSplashPage from './garaSplashPage';

import { getTenantConfig } from '../../config';

const { tenant } = getTenantConfig();

const splashPages = {
  hae_old: GaraSplashPage
};

const SplashPage = () => {
  const [modalOpen, setModalOpen] = useState(true);

  // useEffect(() => {
  //   // set the sploashpage loaded to true when the modal is closed
  //   if (!modalOpen) {
  //     setSplashPageLoaded(true);
  //   }
  // }, [modalOpen]);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  const TenantSplashPage = splashPages[tenant];

  if (!TenantSplashPage) {
    return null; // Return null if no client or splash page exists
  }

  // console.log('SplashPage', tenant);

  return (
    <Dialog open={modalOpen} maxWidth="md" fullWidth>
      <TenantSplashPage toggleModal={toggleModal} />
    </Dialog>
  );
};

export default SplashPage;
